import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import AddConsumptionEquipment from "./AddConsumptionEquipment";
import ViewConsumptionEquipment from "./ViewConsumptionEquipment";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../../Layout/Scope2Layout";
import Cards from "../../../../Components/Common/Cards";
import { getMonthName } from "../../../../utils/getMonthName";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../../utils/formatNumber";
import { truncateNumber } from "../../../../utils/common";
import BulkUpload from "../../BulkUploadEquipment";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";

const ConsumptionByEquipment = () => {
  const { user } = useUser();
  const tableContainerRef = useRef(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [isShortContent, setIsShortContent] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Equipment: false,
    "Consumption Month": false,
    "Units Consumed (KWH)": false,
  });
  const columnWidth = "12% 15% 16% 16% 16% 15% 10%";
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Consumption Month": false,
    Equipment: false,
    "Units Consumed (KWH)": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipment: [],
  });
  const [unitOfConsumption, setUnitOfConsumption] = useState({
    min: "",
    max: "",
  });
  const [cardData, setCardData] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    equipment: [],
    unitOfConsumption: { min: "", max: "" },
  });
  const [formData, setFormData] = useState({});
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [equipmentData, setEquipmentData] = useState([]);

  const equipmentList = async () => {
    const response = await get(`/master/Electricity/getEquipment`);
    console.log(response.data.data, " equipmentList");
    setEquipmentData(response.data.data.map((item) => item.equipment));
    return response.data.data.map((item) => item.equipment);
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [equipment] = await Promise.all([equipmentList()]);

        console.log(equipment, "Final Equipment List");

        // Optionally store them in state

        // Now fetch your excel data
        fetchExcelData();
      } catch (error) {
        console.error("Error fetching equipment or vendors:", error);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const fetchExcelData = async () => {
    await get("/scope2/heatEquipment/heat/equipment")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            Equipment: el?.equipment,
            "Hours Used": "",
            "Remark (optional)": "",
            Document: "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const filters = [
    "Date",
    "Consumption Month",
    "Equipment",
    "Units Consumed (KWH)",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "equipment",
      title: "Equipment",
      placeholder: "Select equipment",
      type: "select",
      url: `/master/Heat/getEquipment`,
      field: "equipment",
      required: true,
    },

    {
      fieldName: "brand",
      title: "Brand",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "model",
      title: "Model",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "usedHours",
      title: "Hours in use",
      placeholder: " Enter Hours",
      type: "number",
    },

    {
      fieldName: "unitOfConsumption",
      title: "Units Consumed",
      placeholder: " Autofilled",
      type: "number",
      adornmentText: "KWH",
    },

    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2/heatEquipment/getHeatEquipement`);
      const data = response.data.data;

      const uniqueIndustrialProcess = [
        ...new Set(
          data.map((el) => el.equipment?.equipment).filter(Boolean) // Filter out undefined values
        ),
      ];

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.vendor?.VendorLegalFullName).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el.industrialEquipment?.name).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipment: uniqueIndustrialProcess,
        vendor: uniqueEquipmentType,
        industrialEquipment: uniqueIndustrialEquipment,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/scope2/heatEquipment/getHeatEquipement?${queryParams}`
      );

      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      // fetchCardData(year, month);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const fetchCardData = async (equipment = "") => {
    try {
      const response = await get(`/scope2/heatEquipment/cardData`, {
        params: { equipment },
      });
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData(
      selectedEquipment ? selectedEquipment : uniqueValues.equipment?.[0]
    );
  }, [selectedEquipment, uniqueValues?.equipment?.[0]]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM-DD")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM-DD")
      : "",
    equipment: tempFilter?.equipment.join(","),
    ...(tempFilter.unitOfConsumption.min
      ? { minUnits: tempFilter.unitOfConsumption.min }
      : {}),
    ...(tempFilter.unitOfConsumption.max
      ? { maxUnits: tempFilter.unitOfConsumption.max }
      : {}),
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Consumption Month": false,
      Equipment: false,
      "Units Consumed (KWH)": false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    //"Consumption Month"
    if (selectedFilter === "Consumption Month") {
      const today = new Date(); // Get the current date

      // Ensure that startMonth and endMonth are not greater than today's date
      if (startMonth && startMonth > today) {
        newErrors.Date = "Start Month cannot be in the future";
        isValid = false;
      }

      if (endMonth && endMonth > today) {
        newErrors.Date = "End Month cannot be in the future";
        isValid = false;
      }

      // Ensure that the startMonth is less than or equal to the endMonth
      if (startMonth && endMonth && startMonth > endMonth) {
        newErrors.Date = "End Month must be greater than Start Month";
        isValid = false;
      }
    }

    if (selectedFilter === "Units Consumed (KWH)") {
      const min = parseFloat(unitOfConsumption.min);
      const max = parseFloat(unitOfConsumption.max);

      console.log("minm", min, max, unitOfConsumption);

      //   if ((min !== "" && min !== undefined && isNaN(Number(min))) ||
      //   (max !== "" && max !== undefined && isNaN(Number(max)))) {
      //     newErrors["Units Consumed (KWH)"] = "Please provide valid min and max values";
      //     isValid = false;
      // } else
      if (min < 0 || max < 0) {
        newErrors["Units Consumed (KWH)"] =
          "Min or Max values cannot be negative";
        isValid = false;
      } else if (min > max) {
        newErrors["Units Consumed (KWH)"] =
          "Min value cannot be greater than Max value";
        isValid = false;
      }
    }
    console.log(selectedFilter, "hi", newErrors);

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    console.log(selectedFields);
    if (!validateFilters()) return;
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setStartMonth(tempFilter.startMonth);
    setEndMonth(tempFilter.endMonth);
    setSelectedFields({
      equipment: tempFilter.equipment,
    });
    setUnitOfConsumption(tempFilter.unitOfConsumption);
    setPage(1);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      endMonth: null,
      startMonth: null,
      equipment: [],
      unitOfConsumption: { min: "", max: "" },
    });

    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipment: [],
    });
    setUnitOfConsumption({ min: "", max: "" });

    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isConsumptionMonth = tempFilter?.startMonth || tempFilter?.endMonth;
    const isEquipmentTypeApplied = selectedFields.vendor?.length > 0;
    // const isEquipmentApplied = selectedFields.equipment?.length > 0;
    const isEquipmentApplied = tempFilter?.equipment?.length > 0;

    const isUnitRangeApplied =
      tempFilter.unitOfConsumption.min || tempFilter.unitOfConsumption.max;

    setIsFiltersApplied(
      isDateApplied ||
        isConsumptionMonth ||
        isEquipmentTypeApplied ||
        isUnitRangeApplied ||
        isEquipmentApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isConsumptionMonth,
      Equipment: isEquipmentApplied,
      "Units Consumed (KWH)": isUnitRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: {
        min: unitOfConsumption.min,
        max: unitOfConsumption.max,
      },
    });
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Role: false });
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    { fieldName: "consumptionPeriod", title: "Consumption Month" },
    { fieldName: "equipment", title: "Equipment" },
    { fieldName: "brand", title: "Brand" },
    { fieldName: "model", title: "Model" },
    { fieldName: "unitOfConsumption", title: "Units Consumed (KWH)" },
  ];

  const handleOpenFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: tempFilter.unitOfConsumption,
    });
    setDrawerFilterOpen(true);
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            title={"Consumption Month"}
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, startMonth: date }))
            }
            setEndMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, endMonth: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Equipment":
        return (
          <MultiSelect
            title="Equipment"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  equipment: newValue.equipment || newValue,
                };
              });
            }}
            errors={errors["Equipment"]}
            setErrors={setErrors}
            field="equipment"
            data={uniqueValues.equipment}
          />
        );

      case "Units Consumed (KWH)":
        return (
          <Range
            title="Units Consumed (KWH)"
            selectedRange={tempFilter.unitOfConsumption}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                unitOfConsumption: range,
              }))
            }
            errors={errors["Units Consumed (KWH)"]}
            setErrors={setErrors}
            placeholderMax="Max(Units)"
            placeholderMin="Min(Units)"
          />
        );
      default:
        return null;
    }
  };

  const handleDropdownChange = (key, value, filterType) => {
    setSelectedEquipment(value); // Update state
  };

  let bannerData = [
    {
      title: "Total Energy Consumed",
      description: cardData?.totalSum ? cardData.totalSum : 0,
      unit: "KWH",
    },
    {
      title: "Top Energy Consuming Equipment",
      description: cardData?.topEquipment?.equipmentName || "N/A",
    },
    {
      title: "Avg. Usage Hours Per Equipment",
      description:
        Array.isArray(cardData?.avgUsageHours) &&
        cardData.avgUsageHours.length > 0
          ? formatNumber(cardData.avgUsageHours[0]?.avgUsageHours)
          : 0,
      // unit: "KWH",
      filter: "option",
      filterTitle: "Tap to Select",
      key: "typeOfSubstance",
      selectedValue: "Select",
      filterValues: uniqueValues?.equipment || [],
      defaultValue: selectedEquipment || uniqueValues?.equipment?.[0],
    },
  ];

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2 | Heating / Cooling">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddConsumptionEquipment
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Consumption by Equipment"
            addUrl={`/scope2/heatEquipment/addHeatEquipement`}
            updateUrl={`/scope2/heatEquipment/updateHeatEquipement`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewConsumptionEquipment
            id={element ? element._id : ""}
            data={element}
            title={"Heating and Cooling Equipment"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
            companyAdmin={user?.companyAdmin}
          />
          <Cards
            data={bannerData}
            title={"Heating and Cooling"}
            onFilterChange={handleDropdownChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              // {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope2/heatEquipment/deleteHeatEquipement`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          <Box>
            {drawerFilterOpen && (
              <FilterDrawer
                {...{
                  renderSelectedFilter,
                  drawerFilterOpen,
                  setDrawerFilterOpen,
                  handleApplyFilters,
                  handleFilterDrawer,
                  setSelectedFilter,
                  handleResetFilters,
                  selectedFilter,
                  filters,
                  appliedFilters,
                  selectedFields,
                  setSelectedFields,
                }}
              />
            )}{" "}
            {/* Top Box for Heading, Filter Button, Add Data Button */}
            <TopMenuUpload
              setData={setElement}
              setAddData={setAddData}
              {...{
                setBulkUploadModal,
                // setDrawerFilterOpen,
                setDrawerFilterOpen: handleOpenFilterDrawer,
                filterApplied: isFiltersApplied,
              }}
            />
          </Box>
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%", marginBottom: "1rem" }}
          >
            <Box>
              <TableHeading heading={"Consumption by Equipment"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData:
                            el.fieldName === "consumptionPeriod"
                              ? getMonthName(item[el.fieldName]?.month) +
                                " " +
                                item[el.fieldName]?.year
                              : el.fieldName === "equipment"
                              ? item.equipment?.equipment || "NA"
                              : el.fieldName === "brand"
                              ? item.equipment?.brand || "NA"
                              : el.fieldName === "model"
                              ? item.equipment?.model || "NA"
                              : el.fieldName === "quantityConsumed"
                              ? truncateNumber(item[el.fieldName].value) +
                                " " +
                                item[el.fieldName].unit
                              : truncateNumber(item[el.fieldName]),
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
        {/* {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            excelData={excelData}
            setsnackOpen={setsnackOpen}
            fileName={"heat equipment"}
            url={"/scope2/heatEquipment/heat/bulkupload"}
          />
        )} */}

        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            formDataBulkUpload={formDataBulkUpload}
            setFormDataBulkUpload={setFormDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            setBulkUploadTable={setBulkUploadTable}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Heat Equipment"}
            url={"/scope2/heatEquipment/heat/bulkupload"}
          />
        )}

        {bulkUploadTable && (
          <BulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            formData={formDataBulkUpload}
            setFormData={setFormDataBulkUpload}
            setFormDatas={setFormData}
            formDatas={formData}
            addNew={false}
            title1="Equipment Name"
            keyValue1="equipment"
            EquipmentURl={`/master/Heat/creatEquipment`}
            options1={equipmentData}
            setEquipmentData={setEquipmentData}
            matched1={"equipmentMatched"}
            onConfirm={() => {
              setBulkUploadTable(false);
              fetchData();
            }}
            jsonBulkUpload={formDataBulkUpload}
            bulkUploadUrl={"/scope2/heatEquipment/heat/jsonUpload"}
            setsnackOpen={setsnackOpen}
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ConsumptionByEquipment;
